import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";

export interface ICityFormMeta {
    oneId: FormInputMeta;
    name: FormInputMeta;
    visaLabel: FormInputMeta;
    country: FormInputMeta;
    schema: any;
  }

const CityFormMeta = {} as ICityFormMeta;

CityFormMeta.oneId = {
    name: "oneId",
    label: "ID",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
CityFormMeta.name = {
    name: "name",
    label: "Nom",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
CityFormMeta.visaLabel = {
    name: "visaLabel",
    label: "Libellé Visq",
    type: "text",
    validation: yup.string().required("Ce champ est requis"),
}
CityFormMeta.country = {
    label: 'Pays',
    name: 'country',
    type: 'select',
    placeholder: 'Select ...',
    options:  [
      {
        label: 'Cameroun',
        value: 'cmr'
      },
      {
        label: 'Tchad',
        value: 'tchad',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}





CityFormMeta.schema = yup.object().shape(getValidationSchema(CityFormMeta));

export default CityFormMeta;
